/**
 * Enum for Tab status(still opened / closed) used for tab-communication
 * @type {Object}
 */
const TabStatusEnum = {
  OPEN: 'open',
  CLOSE: 'close'
};

export default TabStatusEnum;



/** WEBPACK FOOTER **
 ** ./src/enums/TabStatusEnum.js
 **/